<template>
    <div>
        <carousel-section />
        <about-section />
        <icon-description-section />
        <innovative-features-section />
        <store-section />
    </div>
</template>
<script>
import CarouselSection from "./partials/CarouselSection";
import AboutSection from "./partials/AboutSection";
import IconDescriptionSection from "./partials/IconDescriptionSection";
import InnovativeFeaturesSection from "./partials/InnovativeFeaturesSection";
import StoreSection from "./partials/StoreSection";

export default {
    name: "HomePage",

    components: {
        CarouselSection, AboutSection, IconDescriptionSection, InnovativeFeaturesSection, StoreSection,
    },

    mounted() {
        this.$store.dispatch("resetTitle");
    }
}
</script>